<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 28 23"
    fill="currentColor"
  >
    <g>
      <path
        d="M22 8.08V5a3 3 0 0 0-3-3h-1V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18a7 7 0 0 0 1-13.92ZM3 4h1v1a1 1 0 0 0 2 0V4h10v1a1 1 0 0 0 2 0V4h1a1 1 0 0 1 1 1v3H2V5a1 1 0 0 1 1-1Zm0 16a1 1 0 0 1-1-1v-9h14.11a7 7 0 0 0 0 10Zm18 0a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z"
      />
      <path
        d="M23 14h-1v-1a1 1 0 0 0-2 0v1h-1a1 1 0 0 0 0 2h1v1a1 1 0 0 0 2 0v-1h1a1 1 0 0 0 0-2Z"
      />
    </g>
  </svg>
</template>
